import * as React from 'react';
export const MovementUp = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <rect width={24} height={24} rx={12} fill="#F3E4FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 17.158L12 5l7 12.158a18.237 18.237 0 00-14 0z"
      fill="#600CE8"
    />
  </svg>
);
